// extracted by mini-css-extract-plugin
export default {"footerNavbar":"FooterNavbar_footerNavbar__ah6XD"};